module.exports = __webpack_public_path__ + "static/img/installationGuide01.9460efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/IndexImages/installGuild/vn/installationGuide01.png
// module id = 8dwY
// module chunks = 0